var













































ItemTypes = /*#__PURE__*/function (ItemTypes) {ItemTypes["BOX"] = "box";ItemTypes["ROW"] = "row";return ItemTypes;}(ItemTypes || {});




export { ItemTypes };